
export { cq } from "/vercel/path0/styled-system/patterns/cq.mjs"